import api from '../api'
import moment from 'moment'
import io from '../socketio';

const initialState = { quiz: null, follow: true };

export const trivia = {
    namespaced: true,
    state: initialState,
    networkTimeDiff: 0,
    actions: {

        getQuiz({ commit, rootState }, cache){
            // if((cache == undefined || cache == true) && this.state.trivia.quiz != null) 
            //     return Promise.resolve(this.state.trivia.quiz);
            this.networkTimeDiff = rootState.config.networkTimeDiff;
            
            return api.triviaQuiz().then(function (response) {
                    commit('getQuiz', response.data);
                    return Promise.resolve(response.data);
                })
                .catch(function (error) {
                    if(error.response.status != 404) api.baseErrorHendler(error);
                    commit('getQuizFailure');
                    return Promise.reject(error);
                });
        },

        setQuiz({ commit, rootState }, quiz){
            // console.log("SET QUIZ");
            this.networkTimeDiff = rootState.config.networkTimeDiff;
            // console.log(quiz);
            commit('getQuiz', quiz);
            return Promise.resolve(quiz);
        },

        setFollow({ commit }, follow){
            //console.log("SET FOLLOW");
            commit('setFollow', follow);
            return Promise.resolve(follow);
        }
    },
    mutations: {
        getQuizFailure(state) {
            state.quiz = null;
        },
        getQuiz(state, quiz) {
            let netTime = moment.utc() + this.networkTimeDiff;
            quiz.startDateTime =  netTime + moment.duration(quiz.timeToStart);
            quiz.applyStartDateTime = netTime + moment.duration(quiz.timeToApplicationStart);

            // leave room when is connected for other quizes
            if(state.quiz != null && state.quiz.id != quiz.id) {
                io.io.emit('leave', { room: "trivia-quiz:" + state.quiz.id });
                state.follow = true; // new quiz
            }

            // join room
            if(state.quiz == null || state.quiz.id != quiz.id)
                io.io.emit('join', { room: "trivia-quiz:" + quiz.id });

            // don't lose userParticipationStatus
            if(state.quiz != null && state.quiz.id == quiz.id && quiz.userParticipationStatus == undefined) 
                quiz.userParticipationStatus = state.quiz.userParticipationStatus;

            state.quiz = quiz;
        },
        setFollow(state, follow){
            state.follow = follow;
        }
    }
};